<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="float-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="reload" v-bind="attrs" v-on="on">
                mdi-reload
              </v-icon>
            </template>
            <span>Reload releases</span>
          </v-tooltip>
        </div>
        <v-form>
          <v-row justify="center">
            <v-col md="6">
              <v-select
                rounded
                solo
                :items="divisions"
                label="Select a division"
                v-model="division"
              ></v-select>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col justify="justify" md="5">
              <v-row>
                <v-col><h4>Release A</h4></v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    rounded
                    solo
                    :items="environments"
                    label="Environment"
                    v-model="releaseAEnvironment"
                  ></v-select
                ></v-col>
                <v-col
                  ><v-autocomplete
                    :items="releaseAList"
                    item-text="releaseName"
                    v-model="releaseA"
                    rounded
                    solo
                    label="Choose release"
                    return-object
                  >
                  </v-autocomplete
                ></v-col>
              </v-row>
              <v-row>
                <v-col class="text-center caption">
                  <span v-if="releaseA">
                    Go to release :
                    <a target="_blank" :href="releaseA.releaseUrl">{{
                      releaseA.releaseName
                    }}</a>
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="5">
              <v-row>
                <v-col><h4>Release B</h4></v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    rounded
                    solo
                    :items="environments"
                    label="Environment"
                    v-model="releaseBEnvironment"
                  ></v-select
                ></v-col>
                <v-col
                  ><v-autocomplete
                    :items="releaseBList"
                    item-text="releaseName"
                    rounded
                    solo
                    label="Choose release"
                    v-model="releaseB"
                    return-object
                  >
                  </v-autocomplete
                ></v-col>
              </v-row>
              <v-row>
                <v-col class="text-center caption">
                  <span v-if="releaseB">
                    Go to release :
                    <a target="_blank" :href="releaseB.releaseUrl">
                      {{ releaseB.releaseName }}
                    </a>
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col md="6">
              <v-btn
                @click="compare"
                v-if="releaseA && releaseB"
                block
                color="success"
                rounded
              >
                Compare {{ releaseA.releaseName }} with
                {{ releaseB.releaseName }}
              </v-btn>
              <v-btn v-else block disabled rounded>Compare</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-row v-if="releaseNote" justify="center">
      <v-col md="8">
        <release-note :releaseNote="releaseNote"></release-note>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ReleaseNote from './ReleaseNote.vue';
const { mapState, mapActions } = createNamespacedHelpers('releasesNotes');

export default {
  components: { ReleaseNote },
  name: 'ReleaseNoteMaker',
  async created() {
    await this.getReleases();
  },
  data() {
    return {
      division: null,
      releaseA: null,
      releaseAEnvironment: 'PRD',
      releaseB: null,
      releaseBEnvironment: 'PRD',
      environments: ['DEV', 'QAT', 'INT', 'UAT', 'OAT', 'PRD'],
      divisions: ['3DIV', 'FSH', 'FBP', 'WFJ', 'MEITU']
    };
  },
  computed: {
    ...mapState(['releases', 'releaseNote']),

    releaseAList() {
      return this.filterRelease(
        this.division,
        this.releaseAEnvironment,
        this.releaseB
      );
    },
    releaseBList() {
      return this.filterRelease(
        this.division,
        this.releaseBEnvironment,
        this.releaseA
      );
    }
  },
  methods: {
    ...mapActions(['getReleases', 'getReleaseNote']),
    async reload() {
      await this.getReleases();
    },
    filterRelease(division, environment, otherRelease) {
      if (division) {
        return this.releases
          .filter(
            d =>
              d.releaseName.startsWith(division) &&
              d.environment === environment &&
              (otherRelease ? d.releaseId !== otherRelease.releaseId : true)
          )
          .sort((a, b) => new Date(b.date) - new Date(a.date));
      } else {
        return [];
      }
    },
    async compare() {
      await this.getReleaseNote({
        releaseA: this.releaseA,
        releaseB: this.releaseB,
        format: 'json'
      });
    }
  }
};
</script>

<style></style>
